'use client';

import { useState, useEffect } from 'react';

interface FooterProps {
  className?: string;
}

const Footer = ({ className = '' }: FooterProps) => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [currentYear, setCurrentYear] = useState('2025');

  useEffect(() => {
    setIsHydrated(true);
    setCurrentYear(new Date().getFullYear().toString());
  }, []);

  if (!isHydrated) {
    return (
      <footer className={`bg-primary text-primary-foreground ${className}`}>
        <div className="w-full max-w-7xl mx-auto px-6 py-16">
          <div className="h-48 bg-accent/20 animate-pulse"></div>
        </div>
      </footer>
    );
  }

  return (
    <footer className={`bg-primary border-t border-primary-foreground/10 text-primary-foreground ${className}`}>
      <div className="w-full max-w-7xl mx-auto px-6 py-16">
        {/* Simple Editorial Layout - Left Aligned */}
        <div className="flex flex-col max-w-xl">
          {/* Header Block: Firm Name + Subtitle Grouped Together */}
          <div className="flex flex-col space-y-2 mb-8">
            {/* Firm Name */}
            <div className="text-base font-light tracking-wide text-primary-foreground">
              ND LAW
            </div>
            
            {/* Subtitle - Slightly Smaller and Visually Quieter */}
            <div className="text-xs font-light leading-relaxed text-primary-foreground/70">
              International Arbitration & Strategic Dispute Resolution
            </div>
          </div>
          
          {/* Contact Information - Clean International Format */}
          <div className="flex flex-col space-y-1 text-sm font-light text-primary-foreground/70">
            <div>62 Rue de Caumartin</div>
            <div>75009</div>
            <div>Paris</div>
            <div>France</div>
            <div className="pt-2">contact@ndlaw.fr</div>
          </div>
          
          {/* Copyright - Small and Discreet */}
          <div className="pt-8 text-xs font-light text-primary-foreground/60">
            &copy; {currentYear} ND LAW. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;